/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  TrackCommentsResponse,
} from '../models';
import {
    TrackCommentsResponseFromJSON,
    TrackCommentsResponseToJSON,
} from '../models';

export interface GetFanClubFeedRequest {
    mint: string;
    userId?: string;
    offset?: number;
    limit?: number;
}

export interface GetFanClubFeedAliasRequest {
    mint: string;
    userId?: string;
    offset?: number;
    limit?: number;
}

/**
 * 
 */
export class FanClubApi extends runtime.BaseAPI {

    /**
     * @hidden
     * Get the fan club feed for a given artist, including text posts and comments
     */
    async getFanClubFeedRaw(params: GetFanClubFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrackCommentsResponse>> {
        if (params.mint === null || params.mint === undefined) {
            throw new runtime.RequiredError('mint','Required parameter params.mint was null or undefined when calling getFanClubFeed.');
        }

        const queryParameters: any = {};

        if (params.mint !== undefined) {
            queryParameters['mint'] = params.mint;
        }

        if (params.userId !== undefined) {
            queryParameters['user_id'] = params.userId;
        }

        if (params.offset !== undefined) {
            queryParameters['offset'] = params.offset;
        }

        if (params.limit !== undefined) {
            queryParameters['limit'] = params.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (!headerParameters["Authorization"] && this.configuration && this.configuration.accessToken) {
            const token = await this.configuration.accessToken("OAuth2", ["read"]);
            if (token) {
                headerParameters["Authorization"] = token;
            }
        }

        const response = await this.request({
            path: `/fan_club/feed`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackCommentsResponseFromJSON(jsonValue));
    }

    /**
     * Get the fan club feed for a given artist, including text posts and comments
     */
    async getFanClubFeed(params: GetFanClubFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrackCommentsResponse> {
        const response = await this.getFanClubFeedRaw(params, initOverrides);
        return await response.value();
    }

    /**
     * @hidden
     * Get the fan club feed for a given artist (hyphenated alias), including text posts and comments
     */
    async getFanClubFeedAliasRaw(params: GetFanClubFeedAliasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrackCommentsResponse>> {
        if (params.mint === null || params.mint === undefined) {
            throw new runtime.RequiredError('mint','Required parameter params.mint was null or undefined when calling getFanClubFeedAlias.');
        }

        const queryParameters: any = {};

        if (params.mint !== undefined) {
            queryParameters['mint'] = params.mint;
        }

        if (params.userId !== undefined) {
            queryParameters['user_id'] = params.userId;
        }

        if (params.offset !== undefined) {
            queryParameters['offset'] = params.offset;
        }

        if (params.limit !== undefined) {
            queryParameters['limit'] = params.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (!headerParameters["Authorization"] && this.configuration && this.configuration.accessToken) {
            const token = await this.configuration.accessToken("OAuth2", ["read"]);
            if (token) {
                headerParameters["Authorization"] = token;
            }
        }

        const response = await this.request({
            path: `/fan-club/feed`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackCommentsResponseFromJSON(jsonValue));
    }

    /**
     * Get the fan club feed for a given artist (hyphenated alias), including text posts and comments
     */
    async getFanClubFeedAlias(params: GetFanClubFeedAliasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrackCommentsResponse> {
        const response = await this.getFanClubFeedAliasRaw(params, initOverrides);
        return await response.value();
    }

}
